export default __webpack_public_path__ + "static/media/boom.f6fbfd09.jpg";